<template>
    <div id="list">
        <Heading layout="" v-if="!special && windowWidth<1200" icons="!special" style="position:relative;"
                 class="d-flex d-lg-none header">
            <slot></slot>
        </Heading>
<!--        <Filtermenu v-if="!special">-->

<!--        </Filtermenu>-->
        <Heading layout="" v-if="!special && windowWidth>1200" icons="!special" style="position:relative;top:50px;"
                 class="d-none d-lg-flex">
            <slot></slot>
        </Heading>

        <div class="rows layout leistungen" style="" id="results">
            <div class="whole row" v-for="(all,index1) in searchedLeistungen" style="">
                <div :class="{'col-md-4': index2 === index1%3&&!smalllayout, 'col-md-2': index2 !== index1%3||smalllayout, small:smalllayout }"
                     v-for="(a, index2) in all" v-if="a" class="col-8">
                    <router-link :to="shortLink(a.link)" tag="a" class="box">
                        <div v-squared="index2===index1%3?'wide':''" class="bg" v-if="a.featured_media!==0"
                             :style="{backgroundImage:getBackground(getFeatured(a,'medium_large'))}">
                            <!--<img :src="a['_embedded']['wp:featuredmedia'][0].media_details.sizes.thumbnail.source_url" alt="" style="width: 100%;opacity: 0">-->
                        </div>
                        <div class="info">
<!--                        {{getCat()}}-->
                            <h5 v-html="a.title.rendered"></h5>
                            {{a.acf.typ.name}} |
                            <span v-if="a.acf.art">Privatleistung</span>
                            <span v-else>Kassenleistung</span>
                        </div>
                          <div v-if="a.leistungen_types"  class="banner">
                            <div v-for="c in getCats(a.leistungen_types[0])">
                              <img :src="require('@/assets/'+c.name+'_small.png')" alt="">

                            </div>
                          </div>
                    </router-link>
                </div>
            </div>
            <div class="whole row" v-if="searchedLeistungen.length<1">
                <div class="col-4">
                    <h5>Leistungen werden geladen</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store';

    export default {
        store,
        name: 'Leistungsliste',
        data() {
            return {
                searched: []
            }
        },
        components: {
            Heading: () => import('@/components/parts/Heading'),
            Filtermenu: () => import('@/components/layouts/Filtermenu'),
        },
        props: ['header', 'leistungen', 'special', 'small', 'withKonfriedlator'],
        created: function () {
            this.filteredLeistungen()
        },
        methods: {
getCats(obj) {
  let cat = this.leistungscats.filter(l=>obj===l.id)
  return cat
},
            allchunked() {
                let cols = this.smalllayout ? 3 : 3;
                return this.chunkArray(this.leistungen, this.special ? 2 : cols)
            },
            filteredLeistungen(search) {
                if (!this.special) {
                    let filtered = this.leistungen.filter(function (l) {

                        //Art der Leistung
                        let typ = this.filter.type.length > 0 ? this.filter.type.indexOf(l.acf.typ.term_id) !== -1 : true

                        //Versicherung
                        let insurance = l.acf.art ? this.filter.insur.length > 0 ? this.filter.insur.indexOf(0) !== -1 : true
                            : this.filter.insur.length > 0 ? this.filter.insur.indexOf(1) !== -1 : true

                        //Schlagwörter
                        let tags = false
                        if (this.filter.terms.length > 0) {
                            if (l.acf.eigenschaften.length > 0) {
                                l.acf.eigenschaften.forEach(function (e) {
                                    if (this.filter.terms.indexOf(e.term_id) !== -1) tags = true;
                                }.bind(this))
                            }
                        }
                        else tags = true

                        //Konfriedlator
                        let konfriedled = true;

                        // console.log(l.title.rendered)
                        if (this.withKonfriedlator && this.filter.konfriedlator.length > 0) {
                            this.filter.konfriedlator.forEach(function (f, index) {
                                if (f === false) return true;
                                let frage = this.konfriedlator.fragen[index]
                                let answers = l.acf.fragen ? l.acf.fragen[frage.name] : [];
                                // console.log(frage.optionen[f])
                                let s = frage.optionen[f].name
                                let hit = answers ? answers.filter(a => a.label === s).length > 0 : false;
                                if (!hit) konfriedled = false

                            }.bind(this))
                        }
                        // console.log('config' + konfriedled)
                        return typ && insurance && tags && konfriedled;
                    }.bind(this));

                    // Suche

                    let searchoptions = {
                        keys: [
                            {
                                name: 'title.rendered',
                                weight: 0.6
                            }, {
                                name: 'content.rendered',
                                weight: 0.4
                            }
                        ],
                        distance: 3000,
                        threshold: 0.2,
                        includeScore: true,
                        includeMatches: true,
                    }

                    if (this.searchterm.length > 0) {
                        this.$search(this.searchterm, filtered, searchoptions).then(results => {
                            let s = []
                            results.forEach(function (r) {
                                r.item.score = r.score
                                s.push(r.item)
                            }.bind(s))
                            this.searched = s
                        })
                    }
                    else this.searched = filtered
                }
                else this.searched = this.leistungen

            },
        },
        watch: {
            searchterm() {
                this.filteredLeistungen()
            },
            filter: {
                handler: function () {
                    this.filteredLeistungen()
                }, deep: true
            },
            leistungen() {
                this.filteredLeistungen()
            },
            searched() {
                store.commit('filteredLength', {'results': this.searched.length})
            },

        },
        computed: {
          leistungscats() {
            return store.state.leistungscats
          },
            smalllayout() {
                return this.small ? store.state.smalllayout : false;
            },
            filter() {
                return store.state.filter
            },
            versicherungen() {
                return store.state.versicherungen
            },
            searchedLeistungen() {
                let cols = this.smalllayout ? 3 : 3;
                return this.chunkArray(this.searched, this.special ? 2 : cols);
            },
            searchterm() {
                return store.state.searchterm
            },
            konfriedlator() {
                return store.state.konfriedlator
            },
        },
        directives: {
            squared: {
                inserted(el, binding, vnode) {
                    // !!! Spezialberechnung für Leistungsboxen !!!
                    let width = jQuery(el).parent('.box').width();
                    let small = vnode.context.smalllayout
                    let mobile = vnode.context.windowWidth < 768
                    let padding = vnode.context.windowWidth < 1200 ? 30 :80;
                    if (mobile || (binding.value === 'wide' && !small )) {
                        jQuery(el).css('height', (width - padding) / 2)
                    }
                    else {
                        jQuery(el).css('height', width)
                    }
                },
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" scoped>
    .header {
        top: -50px;
        @include tablet {
            top: 0;
        }
    }

    .banner {
      position: absolute;
      right: 0;
      bottom: 0;
      img {
        height: 15px;

      }
    }

    .small {
      .banner {
        img {
          height: 15px;
        }
      }
    }

    h5 {
        color: #666;
    }

    #results {
        position: relative;
        top: 50px;
        @include mobile {
            display: flex;
            flex-wrap: wrap;
        }
        @include tablet {
            top: 0;
        }
    }

    .rows {
        margin-bottom: 50px;
        @include mobile {
            margin-bottom: 10px;
        }
        .row {

            &:nth-child(even) {
              //  flex-direction: row-reverse;
            }
        }

    }

    .box {
        display: block;
        cursor: pointer;
        text-align: left;
      position: relative;
        transition: all 0.2s ease;
        width: 100%;

        &:hover {
            transform: scale(1.05);
            box-shadow: 0px 0px 10px #ddd;
            .info {
                background-color: #fff;
            }
        }
        &.router-link-active {

        }
        .bg {
            background-position: center center;
            background-size: cover;
        }
    }

    #results {

        .whole {
            margin-top: 20px;
            margin-bottom: 40px;
            @include laptop {
                .small {
                    flex: 0 0 33% !important;
                    max-width: 33%;
                }
                /*margin-right: 8%;*/
                /*justify-content: space-between;*/
            }
            @include mobile {
                margin-top: 0;
                margin-bottom: 0;
                flex: 0 0 50%;
                max-width: 50%;
                .small {
                    margin: 10px 0px;
                    flex: 0 0 100% !important;
                    max-width: 100% !important;
                    .box {
                        transform: scale(1);
                    }
                }
            }
            @include phone {
                flex: 0 0 100%;
                max-width: 100%;
                .small {
                    a {

                        box-shadow: 0px 0px 10px #ddd;
                    }
                }
            }
            .small {
                line-height: 1.5em;
                height: 100px;

                a {
                    box-shadow: 0px 0px 10px #ddd;
                }
                @include mobile {
                    min-height: 100px;
                    .bg {
                        min-width: 80px;

                    }
                }
                h5 {
                    font-size: 12px;
                    line-height: 18px;
                }
                .box {
                    align-content: stretch;
                    display: flex;
                    height: 100%;
                    .bg {
                        width: 30%;
                        flex: 0 0 30%;
                        height: auto !important;
                        min-width: 100px;
                        img {
                        }
                    }
                    .info {
                        padding: 10px 20px;
                    }
                }
            }
        }
    }
    .info {
        color: darken($gray, 10%);
        text-align: left;
        padding: 10px;
        margin-bottom: 10px;
        overflow: hidden;
      position: relative;
      padding-bottom: 20px;
    }

    h5 {
    }

    .infowrap {
    }
</style>



// WEBPACK FOOTER //
// src/components/parts/Leistungsliste.vue